import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-contract-token',
    templateUrl: './contract-token.component.html',
    styleUrls: ['./contract-token.component.css']
})
export class ContractTokenComponent implements OnInit {

    docuSignUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl('');

    private applicationId: number;
    private token: string;

    constructor(
        private connectionService: ConnectionService,
        public router: Router,
        private sanitizer: DomSanitizer,
        private authService: AuthService
    ) {
        const navigation = this.router.getCurrentNavigation();
        if (navigation.extras.state) {
            this.applicationId = navigation.extras.state.applicationId;
            this.token = navigation.extras.state.token;
        } else {
            this.router.navigateByUrl('/');
        }
    }

    ngOnInit(): void {
        this.authService.validateToken(this.token).then((data: any) => {
            if (data.msg == 'Valid token.') {
                window.scroll(0, 0);
                this.getSignDocusign();
            } else {
                this.router.navigate(['signin']);
            }
        }).catch((error) => {
            this.router.navigate(['signin']);
        });
    }

    getSignDocusign() {
        return new Promise((resolve, reject) => {
            this.connectionService.getCustomRequest(
                environment.gateway + 'signDocusignNl/' + this.applicationId,
                'application/json', null, 'token', this.token).subscribe(
                    (data: any) => {
                        this.docuSignUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.object);
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
    }

}
